// -*- mode: vue; js-indent-level: 2; -*-
<template lang="html">
    <router-link :to="{name: 'beer-detail', params: {slug: beer.slug || beer.name}}">
      <div class="beer-card">
        <img class="beer-label-round" :src="beer.imageUri|product_image_url" :alt="displayName">
        <h3>{{ displayName }}</h3>
      </div>
    </router-link>
</template>


<script lang="js">
export default {
  name: 'BeerCard',
  props: ['beer'],

  computed: {
    displayName: function () {
      return this.beer.nomCommercial || this.beer.nom || this.beer.web_name || this.beer.name
    }
  },

  filters: {
    product_image_url (uri) {
      if (!uri) {
        return ''
      }
      if (uri.startsWith('http://') || uri.startsWith('https://')) {
        return uri
      }
      return 'https://erp.singe-savant.com/' + uri
    }
  }
}
</script>


<style lang="scss" scoped>
a {
    text-decoration: none;
    
    &:hover {
        text-decoration: none;
    }
}

.beer-card {
    color:black;
    font-variant: small-caps;
    padding-bottom: 5vh;

    h3 {
        font-size: 1.5em;
    }

    img {
        transition: all .3s ease-in-out;
    }

    &:hover {

      img {
        transition: all .3s ease-in-out;
        transform: scale(1.05);
      }
    }

    .beer-label-round {
        border: 1px solid black;
        width: 90%;
        object-fit: fill;
        clip-path: circle(35% at center);

        padding: 0px;
        margin: -30px;
    }

}
</style>
